import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=775b7ea0&scoped=true&"
import script from "./Expense.vue?vue&type=script&lang=js&"
export * from "./Expense.vue?vue&type=script&lang=js&"
import style0 from "./Expense.vue?vue&type=style&index=0&id=775b7ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b7ea0",
  null
  
)

export default component.exports